import { render } from "./PromiseRender.vue?vue&type=template&id=fb458b42"
import script from "./PromiseRender.vue?vue&type=script&lang=js"
export * from "./PromiseRender.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__